module.exports = __webpack_public_path__ + "img/banner.bba02138.jpg";